
<script>
  // Extensions
  import View from '@/views/View'

  // Mixins
  import LoadSections from '@/mixins/load-sections'

  export default {
    name: 'Call for Papers',

    metaInfo: { title: 'Call for Papers' },

    extends: View,

    mixins: [
      LoadSections([
        'call-for-papers',
      ]),
    ],

    props: {
      id: {
        type: String,
        default: 'call-for-papers',
      },
    },
  }
</script>
